import React from "react";
import License from "./License";
import Company from "./Company";
import Driver from "./Driver";
import MyCheckbox from "@common-components/checkbox/CheckBox";
import "../cards/DarkCard.scss";

const CCP_ActionCards = ({ data }) => {
  let bgColor = "";

  switch (data?.status?.description?.toLowerCase()) {
    case "completed":
      bgColor = "bg-green-300";
      break;
    case "on hold":
      bgColor = "bg-gray-300 text-gray-700";
      break;
    case "in progress":
      bgColor = "bg-yellow-300 text-gray-700";
      break;
    case "new":
      bgColor = "bg-blue-300";
      break;
    default:
      bgColor = "bg-gray-200 text-gray-700";
  }

  //   performedBy
  // description
  // approvedBy
  // noBrokenGlass
  // noLooseMetalFragments
  // status
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-3 gap-2">
        <ul className="bg-gray-50 p-3 border rounded-md list-none dark-bg">
          <li className="flex items-center justify-between py-3">
            <p className="mb-0 font-semibold">Date:</p>
            <p className="mb-0">{data?.createdDateUTC?.split("T")[0]}</p>
          </li>
          <li className="flex items-center justify-between py-3">
            <p className="font-semibold mb-0">Status:</p>
            <div
              className={`${bgColor} rounded h-6 px-2 flex items-center justify-center`}
            >
              <p className="mb-0">{data?.status?.description}</p>
            </div>
          </li>
          <li className="flex items-center justify-between py-3">
            <p className="mb-0 font-semibold">Test Type:</p>
            <p className="mb-0">
              {data?.type === 1 ? "Production Startup" : "End Production"}
            </p>
          </li>
          <li className="flex items-center justify-between py-3">
            <p className="mb-0 font-semibold">Performed By:</p>
            <p className="mb-0">{data?.performedBy}</p>
          </li>

          <li className="flex items-center justify-between py-3">
            <p className="mb-0 font-semibold">Approved By:</p>
            <p className="mb-0">{data?.approvedBy}</p>
          </li>
          <li className="flex flex-col items-start space-y-3 lg:space-y-0 justify-between py-3">
            <p className="mb-0 font-semibold">Description:</p>
            <p className="mb-0">{data?.description}</p>
          </li>
        </ul>
        <ul className="bg-gray-50 p-3 border rounded-md list-none dark-bg">
          {data?.type === 1 && (
            <li className="flex items-center justify-between py-3">
              <p className="mb-0 font-semibold">No Broken Glass:</p>
              <p className="mb-0">{data?.noBrokenGlass ? "Ok" : "Not Ok"}</p>
            </li>
          )}
          {data?.type === 1 && (
            <li className="flex items-center justify-between py-3">
              <p className="mb-0 font-semibold">No Loose Metal Fragments: </p>
              <p className="mb-0">{data?.noBrokenGlass ? "Ok" : "Not Ok"}</p>
            </li>
          )}
          {data?.type === 2 && (
            <li className="flex items-center justify-between py-3">
              <p className="mb-0 font-semibold">
                Knives at Production Startup:
              </p>
              <p className="mb-0">{data?.knivesAtProductionStartUp}</p>
            </li>
          )}
          {data?.type === 2 && (
            <li className="flex items-center justify-between py-3">
              <p className="mb-0 font-semibold">Knives at End Production:</p>
              <p className="mb-0">{data?.knivesAtProductionEnd}</p>
            </li>
          )}
          {data?.type === 2 && (
            <li className="flex items-center justify-between py-3">
              <p className="mb-0 font-semibold">
                Scissors at Production Startup:{" "}
              </p>
              <p className="mb-0">{data?.scissorsAtProductionStartUp}</p>
            </li>
          )}
          {data?.type === 2 && (
            <li className="flex items-center justify-between py-3">
              <p className="mb-0 font-semibold">Scissors at End Production:</p>
              <p className="mb-0">{data?.scissorsAtProductionEnd}</p>
            </li>
          )}
          {data?.type === 2 && (
            <li className="flex items-center justify-between py-3">
              <p className="mb-0 font-semibold">Knives:</p>
              <p className="mb-0">{data?.knives ? "Ok" : "Not Ok"}</p>
            </li>
          )}
          {data?.type === 2 && (
            <li className="flex items-center justify-between py-3">
              <p className="mb-0 font-semibold">Scissors:</p>
              <p className="mb-0">{data?.scissors ? "Ok" : "Not Ok"}</p>
            </li>
          )}
        </ul>
      </div>
    </>
  );
};

export default CCP_ActionCards;
